import { firstWordExtraBold } from './modules/_first-word-extra-bold'

jQuery(($) => {
  let titleLeft = $('.layout-left').find('h2')
  let titleRight = $('.layout-right').find('h2')

  firstWordExtraBold(titleLeft)
  firstWordExtraBold(titleRight)
})
